import styled from 'styled-components'

const ItemImage = styled.img`
  display: block;
  pointer-events: none;
  width: ${(p) => (p.width ? p.width : '100%')};
  position: ${(p) => (p.overlay ? 'absolute' : undefined)};
  visibility: ${(p) => (p.hidden ? 'hidden' : undefined)};
  top: ${(p) => (p.top ? p.top : undefined)};
  left: ${(p) => (p.left ? p.left : undefined)};
  bottom: ${(p) => (p.bottom ? p.bottom : undefined)};
`

export default ItemImage



// WEBPACK FOOTER //
// ./src/components/ItemImage.js